import { Superstar } from './superstar.type';

export enum RosterLevelEnum {
  'B' = 'B',
  'S' = 'S',
  'G' = 'G',
}

export enum TierLevelEnum {
  'SPlus' = 'SPlus',
  'S' = 'S',
  'A' = 'A',
  'B' = 'B',
  'C' = 'C',
  'Other' = 'Other',
}

export type RosterLevelType = `${RosterLevelEnum}`;
export type TierLevelType = `${TierLevelEnum}`;
export interface PlayerRosterForClubStore {
  id: string;
  name: string;
  title: string;
  description: string | undefined;
  price: number | undefined;
  star: number | undefined;
  level: RosterLevelType | undefined;
  img: string | undefined;
  rosterId: number;
  tier: string;
  hollowStar: number;
  disabled?: boolean;
}

export interface PlayerRosterV2 extends Superstar {
  level: string;
  stars: number;
  hollowStars: number;
  solidStars: number;
}
